import { Alert } from '@/global/components/Alert'
import { Chip } from '@/global/components/Chip'
import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import IconeAjuda from '@/global/components/IconeAjuda'
import Skeleton from '@/global/components/Skeleton'
import { columnsTransacoes } from '@/templates/Planos/MinhaAssinatura/DataGridTransacoes'
import LinearProgress from '@/global/components/LinearProgress'
import ContentGuide from 'global/guides/ContentGuide'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import { clientes, transacoesCliente } from 'service/api'

export default function FinanceiroCliente() {
    const { clienteId } = useParams()
    const { data } = clientes.useFetchById(Number(clienteId), {
        enabled: !!clienteId,
    })
    const {
        data: transacoes,
        error,
        isError,
        isLoading,
    } = transacoesCliente.useFetch({
        queryParams: { clienteId: Number(clienteId) },
        enabled: !!clienteId,
    })

    return !data && !transacoes ? (
        <Dialog.Root width="lg">
            <Dialog.Title>
                <Skeleton className="w-50 h-7" />
                <div style={{ flexGrow: 1, minWidth: 80 }} />
                <Skeleton className="w-25 h-7" />
            </Dialog.Title>
            <Dialog.Content>
                <div style={{ flexGrow: 1 }} />
                <LinearProgress />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    ) : (
        <Dialog.Root disableFields>
            <Dialog.Title>
                Detalhes financeiros do cliente
                <StatusCliente status={data?.status} />
            </Dialog.Title>
            <Dialog.Content>
                <div className="w-full">
                    <span className="text-sm inline-flex items-center">
                        Email financeiro{' '}
                        <IconeAjuda size="small">
                            Esse é o email que consta na última transação do
                            cliente no CelCash, e para onde são enviados os
                            emails de cobranças, notas fiscais e outros.
                            <br />
                            Caso o cliente ainda não tenha feito nenhuma
                            transação, esse campo pode estar vazio.
                        </IconeAjuda>
                    </span>
                    <span className="text-base font-normal block mt-1">
                        {transacoes
                            ?.at(0)
                            ?.Subscription?.Customer?.emails?.at(-1) ||
                            'Não registrado'}
                    </span>
                </div>
                <div>
                    <HorizontalDivider className="my-4 select-none">
                        Últimas transações
                    </HorizontalDivider>
                    <ContentGuide.DataGrid
                        className="h-75"
                        columns={columnsTransacoes.filter(
                            c => c.field !== '__opcoes',
                        )}
                        rows={transacoes?.map((item, id) => ({
                            ...item,
                            id,
                        }))}
                        hideFooter
                        ToolbarProps={{
                            hideToolbar: true,
                        }}
                        error={isError}
                        loading={isLoading}
                        components={{
                            ErrorOverlay: () => (
                                <Alert
                                    severity="error"
                                    className="w-fit self-center my-auto"
                                >
                                    {(error as any)?.message ||
                                        'Erro ao carregar transações'}
                                </Alert>
                            ),
                        }}
                    />
                </div>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}

const StatusCliente = ({ status }: { status?: string }) => {
    switch (status) {
        case 'active':
            return <Chip label="Ativo" color="success" />
        case 'inactive':
            return <Chip label="Inativo" color="error" />
        case 'delayed':
            return <Chip label="Atrasado" color="warning" />
        case 'withoutSubscriptionOrCharge':
        default:
            return <Chip label="Sem assinatura" color="info" />
    }
}
